import { Box, CardContent, Grid, Stack, Typography } from '@mui/material';
import { Card } from 'reactstrap';
import colors from '../../../../../assets/theme/base/colors';
import { MDBox } from '../../MDBox';
import { useEffect, useState } from 'react';
import { EmploymentEquityDashboardDto } from '../../../../Model/Dto/EmploymentEquity/Dashboard';
import { FieldValues, useForm } from 'react-hook-form';
import { IncomeDifferentialAnalysisSchema } from './IncomeDifferentialAnalysisValidation';
import { yupResolver } from "@hookform/resolvers/yup";
import AppSelectList from '../../FormValidationInputs/AppSelectList';
import {  EEOccupationalLevelList, genderList, PercentageList, raceList, RemunerationTypeList } from '../../../Constants/Lists/DropdownListOptions';
import { MDButton } from '../../MDButton';
import {DashboardService} from '../../../../Api/EmploymentEquity/Dashboard/DashboardService';
import { ChartType } from '../../../../Model/Enum/ChartType';

interface IProps {
  scorecardId?: string;
  chartType: ChartType;
  sourceScorecardIds?: string[];
}

const { dark } = colors;

export const EmploymentEquity1BlockChart = (props: IProps) => {

  const { control, handleSubmit } = useForm({
    mode: 'all',
    resolver: yupResolver(IncomeDifferentialAnalysisSchema)
  });
  const [IncomeDifferrentialDto, setIncomeDifferentialDto] = useState<EmploymentEquityDashboardDto.IncomeDifferentialAnalysisDtoOut>();
  const [TopTileLabel, setTopTileLabel] = useState<string>();
  const [BottomTileLabel, setBottomTileLabel] = useState<string>();

  useEffect(() => {
    getData();
  }, [props.sourceScorecardIds]); // eslint-disable-line react-hooks/exhaustive-deps

  const getData = async () => {
    const chart = props.chartType;
    if (chart === ChartType.IncomeDifferential1Analysis ){
      const data = localStorage.getItem('IncomeDifferential1Analysis');
      if (data){

        const formData = JSON.parse(data) as EmploymentEquityDashboardDto.IncomeDifferentialAnalysisDtoIn;
        setTopTileLabel(getLabelsFromDtoIn(formData.topTile));
        setBottomTileLabel(getLabelsFromDtoIn(formData.bottomTile));
        const result = await DashboardService.GetIncomeDifferentialsAnalysis(formData);
        if (result) {
          setIncomeDifferentialDto(result.data);
        } 
      }
   }else if (chart === ChartType.IncomeDifferential2Analysis){
      const data = localStorage.getItem('IncomeDifferential2Analysis');
      if (data){
        const formData = JSON.parse(data) as EmploymentEquityDashboardDto.IncomeDifferentialAnalysisDtoIn;
        setTopTileLabel(getLabelsFromDtoIn(formData.topTile));
        setBottomTileLabel(getLabelsFromDtoIn(formData.bottomTile));
        const result = await DashboardService.GetIncomeDifferentialsAnalysis(formData);
        if (result) {
          setIncomeDifferentialDto(result.data);
        } 
      }
    }
  }


  const handleDataSubmit = async (data: FieldValues) => {
    const topTileData = data.topTile;
    const bottomTileData = data.bottomTile;
    if (topTileData && bottomTileData) {
      setTopTileLabel(getLabelsFromDtoIn(topTileData as EmploymentEquityDashboardDto.Tile));
      setBottomTileLabel(getLabelsFromDtoIn(bottomTileData as EmploymentEquityDashboardDto.Tile));

      const formData = {
        topTile: topTileData as EmploymentEquityDashboardDto.Tile,
        bottomTile: bottomTileData as EmploymentEquityDashboardDto.Tile,
        scorecardId: props.scorecardId,
        sourceScorecardIds: props.sourceScorecardIds ? props.sourceScorecardIds : undefined
      } as EmploymentEquityDashboardDto.IncomeDifferentialAnalysisDtoIn;

      const result = await DashboardService.GetIncomeDifferentialsAnalysis(formData);
      if (result) {
        setIncomeDifferentialDto(result.data);
        saveToLocalStorage(formData);
      }

    }
  };
  
  const saveToLocalStorage = (data: EmploymentEquityDashboardDto.IncomeDifferentialAnalysisDtoIn) => {
    if (props.chartType === ChartType.IncomeDifferential1Analysis){
      localStorage.setItem('IncomeDifferential1Analysis', JSON.stringify(data));
    }
    if (props.chartType === ChartType.IncomeDifferential2Analysis){
      localStorage.setItem('IncomeDifferential2Analysis', JSON.stringify(data));
    }
  }


  const getLabelsFromDtoIn = (data: any) : string => {
      const RemunerationType = RemunerationTypeList.find(x => x.id === data.RemunirationTypeId)?.value;
      const Percentage = PercentageList.find(x => x.id === data.Percentage)?.value;
      const OccupationalLevel = EEOccupationalLevelList.find(x => x.id === data.OccupationalLevelId)?.value;
      const gender = genderList.find(x => x.id === data.GenderId)?.value;
      const race = raceList.find(x => x.id === data.RaceId)?.value;

      return `${RemunerationType} ${Percentage} for ${race} ${gender} ${OccupationalLevel}`;
  }
  const renderCard = (label: string,label2: string) => {
    return (
      <Grid item padding={1}>
        <Card sx={{ height: "100px", justifyContent: "center" }} >
          <CardContent sx={{ width: "100%" }}>
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" width="100%">
              <Typography variant='h5' color={dark.main} mb={1}>{label}</Typography>
              <Typography variant='h5' color={dark.main}>{label2}</Typography>
            </Box>
          </CardContent>
        </Card>
      </Grid >
    )
  }

 
  return (
    <MDBox sx={{ width: '100%' }}>
      {IncomeDifferrentialDto == null ? <form onSubmit={handleSubmit(handleDataSubmit)}>
        <Typography variant="h6">Top Tile</Typography>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12}>
            <AppSelectList
              control={control}
              name="topTile.GenderId"
              label="Gender"
              items={genderList}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <AppSelectList
              control={control}
              name="topTile.RaceId"
              label="Race"
              items={raceList}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <AppSelectList
              control={control}
              name="topTile.OccupationalLevelId"
              label="Occupation"
              items={EEOccupationalLevelList}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <AppSelectList
              control={control}
              name="topTile.Percentage"
              label="Percentage"
              items={PercentageList}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <AppSelectList
              control={control}
              name="topTile.RemunirationTypeId"
              label="Remuneration Type"
              items={RemunerationTypeList}
            />
          </Grid>
        </Grid>

        <Typography variant="h6">Bottom Tile</Typography>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12}>
            <AppSelectList
              control={control}
              name="bottomTile.GenderId"
              label="Gender"
              items={genderList}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <AppSelectList
              control={control}
              name="bottomTile.RaceId"
              label="Race"
              items={raceList}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <AppSelectList
              control={control}
              name="bottomTile.OccupationalLevelId"
              label="Occupation"
              items={EEOccupationalLevelList}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <AppSelectList
              control={control}
              name="bottomTile.Percentage"
              label="Percentage"
              items={PercentageList}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <AppSelectList
              control={control}
              name="bottomTile.RemunirationTypeId"
              label="Remuneration Type"
              items={RemunerationTypeList}
            />
          </Grid>
        </Grid>
        <MDButton variant="gradient" color="info" type="submit">Submit</MDButton>
      </form>: 
      <Stack>
        {renderCard(`${TopTileLabel}`,`${IncomeDifferrentialDto.topTile}`)}
        {renderCard(`${BottomTileLabel}`,`${IncomeDifferrentialDto.bottomTile}`)}
        {renderCard(`Income Differential Ratio`,`${IncomeDifferrentialDto.incomeRatio}`)}
        <MDButton variant="gradient" color="info" onClick={() => setIncomeDifferentialDto(undefined)}>Reset</MDButton>
      </Stack>
      }
    </MDBox>
  )
}

